import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
export default function DropdownModal(props) {
  const { label, items, description, value, identifier, inputFromUser, id } =
    props;
  const handleChange = (e) => {
    inputFromUser(identifier, e.target.value);
  };
  return (
    <div className="inputDiv" id={id}>
      <FormControl fullWidth>
        <InputLabel
          className="floatingLabelFocusStyle "
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            margin: "0px 13px",
            // border: "1px solid #606060",
          }}
          id="demo-simple-select-label"
        >
          {label}
        </InputLabel>
        <Select
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            margin: "0px 13px",
            // border: "1px solid #606060",
          }}
          labelId="demo-simple-select-label"
          label={label}
          value={value}
          onChange={handleChange}
        >
          {items.map((item, idx) => {
            return (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <p className="inputDescription">{description}</p>
    </div>
  );
}
